import React from "react"
import styled from "styled-components"
import { device } from "../devices"

const HamburguerButton = props => {
  return (
    <Button {...props}>
      <div></div>
      <div></div>
      <div></div>
    </Button>
  )
}

const Button = styled.button`
  background: none;
  border: none;
  color: var(--color-blanco);
  cursor: pointer;
  outline: none;
  padding: 0;
  margin: 0;
  z-index: 100;
  width: 40px;
  height: 40px;

  > div {
    position: relative;
    top: 0;
    height: 3px;
    background-color: #fff;
    margin-bottom: 7px;
    transition: 0.3s ease transform, 0.3s ease top, 0.3s ease width,
      0.3s ease right;
    border-radius: 2px;

    :first-child {
      transform-origin: 0;
    }

    :nth-child(2) {
      right: 0;
    }

    :last-child {
      margin-bottom: 0;
      transform-origin: 30px;
      margin-bottom: 0;
    }
  }

  &.close {
    > div {
      :first-child {
        transform: rotateZ(45deg);
        left: 5px;
        top: -5px;
      }

      :nth-child(2) {
        transform: rotateZ(-45deg);
        top: -1px;
        right: 1px;
      }

      :last-child {
        opacity: 0;
      }
    }
  }

  ${device.tablet} {
    display: none;
  }
`

export { HamburguerButton }
